
import { EMPTY_STRING } from "@/utils/Constants";
import { Component, Vue } from "vue-property-decorator";

@Component({
	components: {
		Paginator: () => import("@/components/Paginator.vue"),
		SortColumn: () => import("@/components/SortColumn.vue"),
		Selectize: () => import("vue2-selectize"),
		Modal: () => import("@/components/Modal.vue"),
	},
})
export default class UsersContracts extends Vue {
	user: any = {
		id: EMPTY_STRING,
		firstName: EMPTY_STRING,
		lastName: EMPTY_STRING,
		email: EMPTY_STRING,
		roleId: null,
		subscriptor: {
			fullname: EMPTY_STRING,
			business: {
				id: EMPTY_STRING,
				name: EMPTY_STRING
			}
		}
	};

	branches: any = [];
	selectedBranches: any = [];
	selectizeOptions: Record<string, any> = {
		plugins: [{ name: "remove_button", options: { label: "", title: "Quitar ramo" }}],
		delimiter: ",",
		persist: true,
	};

	companies: any = [];
	assignedCompanies: any = [];
	company: any = {
		id: EMPTY_STRING
	};
	companyToRemove: any = {
		id: EMPTY_STRING
	}
	filter: any = {
		businessId: EMPTY_STRING
	};
	sortColumns: Record<string, string> = {
		name: "Empresa",
		owner: "Responsable",
		deletedAt: "Estado"
	};
	currentSort: Record<string, string> = {
		col: "name",
		dir: "asc"
	};
	totalRows: number = 0;
	limit: number = 10;

	async mounted() {
		await this.loadUser();
		this.loadCompanies(1, this.currentSort);
		this.loadBranches();
	}

	async loadUser() {
		const userId = this.$route.params.id;
		const response: any = await (this.$root as any)._get(`users/${userId}`);
		this.user = response;

		this.selectedBranches = this.user.subscriptor.branches.map((b) => b.id);

		this.filter = {
			businessId: this.user.subscriptor.business.id
		};
	}

	async loadBranches() {
		const response: any = await (this.$root as any)._get("branches", { includeDeleted: true });
		this.branches = response.data;
	}

	onPageChange(page: number, limit: number) {
		this.limit = limit;
		this.loadCompanies(page, this.currentSort);
	}

	async loadCompanies(page: number, sort: Record<string, string>) {
		const assignedCompaniesResponse: any = await this.getCompanies(false, page, sort);
		this.assignedCompanies = assignedCompaniesResponse.data;

		const unassignedCompaniesResponse: any = await this.getCompanies(true);
		this.companies = unassignedCompaniesResponse.data;
	}

	async getCompanies(excludeAssigned: boolean = false, page: number = null, sort: Record<string, string> = null) {
		const response: any = await (this.$root as any)._get(`subscriptors/${this.user.subscriptor.id}/companies`, {
			limit: this.limit,
			page: page,
			order: this.currentSort,
			exclude: excludeAssigned,
			businessId: excludeAssigned ? this.filter.businessId : null
		});

		return response;
	}

	reloadBranches() {
		this.selectedBranches = this.user.subscriptor.branches.map((b) => b.id);
	}

	async updateBranches() {
		try {
			await (this.$root as any)._patch(`subscriptors/${this.user.subscriptor.id}/branches`, {
				branchIds: this.selectedBranches
			});

			(this.$root as any).notify("Los ramos del suscriptor fueron actualizados.");

			this.loadUser();
		} catch (error) {
			(this.$root as any).notify("No fue posible actualizar los ramos del suscriptor. Intente nuevamente.", "error");
		}
	}

	async associate() {
		try {
			await (this.$root as any)._post(`companies/${this.company.id}/subscriptors/${this.user.subscriptor.id}`);

			(this.$root as any).notify(`El contrato ${this.company.name} fue asignado al suscriptor.`);

			this.clear();
			this.loadCompanies(1, this.currentSort);
		} catch (error) {
			(this.$root as any).notify("No fue posible asociar el contrato al suscriptor. Intente nuevamente.", "error");
		}
	}

	showRemoveModal(selectedCompany: any) {
		this.companyToRemove = selectedCompany;
		(this.$refs.modal as any).show();
	}

	async remove() {
		try {
			await (this.$root as any)._delete(`companies/${this.companyToRemove.id}/subscriptors/${this.user.subscriptor.id}`);

			(this.$root as any).notify(`El contrato ${this.companyToRemove.name} fue quitado del suscriptor.`);

			this.clearRemove();
			this.loadCompanies(1, this.currentSort);
			(this.$refs.modal as any).hide();
		} catch (error) {
			(this.$root as any).notify("No fue posible quitar el contrato del suscriptor. Intente nuevamente.", "error");
			return;
		}
	}

	clear() {
		this.company = { id: EMPTY_STRING };
	}

	clearRemove() {
		this.companyToRemove = { id: EMPTY_STRING };
	}

	getSubscriptorName() {
		if (!this.user) return EMPTY_STRING;

		if (this.user.firstName && this.user.lastName) return `${this.user.firstName} ${this.user.lastName}`;
		else return this.user.subscriptor.fullname
	}
}
